<template>
  <div class="modal false z-50 fixed w-full h-full top-0 left-0 flex items-center justify-center">
    <div class="absolute w-full h-full bg-gray-900 opacity-50 modal-overlay"
         @click="$emit('close')"></div>
    <div class="z-50 w-11/12 mx-auto bg-white rounded shadow-lg modal-container md:max-w-3xl">
      <div class="flex-auto">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <Form class="text-base leading-relaxed"
                @submit="submit">
            <!-- header -->
            <div class="flex justify-between items-start p-5 rounded-t border-b dark:border-gray-600">
              <h3 class="text-lg font-semibold text-gray-900 lg:text-xl dark:text-white">
                {{ $lang.app.ADD_SIGNERS }}
              </h3>
              <button
                  @click="$emit('close')"
                  type="button"
                  class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5
                ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white">
                <XIcon class="w-5 h-5"/>
              </button>
            </div>
            <!-- body -->
            <div class="p-6 modal-body custom-scrollbar overflow-y-auto">
              <div v-if="userResolutionRole !== 'ROLE_HEAD_OF_DEPARTMENT'" class="mb-4">
                <div class="mb-1">
                  <label class="block text-blue-400 text-sm" :for="`state-input`">
                    {{ $lang.app.SUBDIVISION }}
                  </label>
                </div>
                <div>
                  <Field :id="`state-input`"
                         :name="`state`" v-slot="{ field }">
                    <Multiselect
                        class="border border-blue-400"
                        v-bind="field"
                        v-model="state"
                        :options="helper.stateOptions"
                        :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                        valueProp="value"
                        :searchable="true"
                        :noOptionsText="$lang.app.LIST_EMPTY"
                        :noResultsText="$lang.app.NOT_FOUND">
                    </multiselect>
                  </Field>
                  <ErrorMessage :name="`state`" class="text-xs text-red-400"/>
                </div>
              </div>
              <div v-if="userResolutionRole !== 'ROLE_HEAD_OF_DEPARTMENT'" class="mb-4">
                <div class="mb-1">
                  <label class="block text-blue-400 text-sm" :for="`department-input`">
                    {{ $lang.app.DEPARTMENT }}
                  </label>
                </div>
                <div>
                  <Field :id="`department-input`"
                         :name="`department`" v-slot="{ field }">
                    <Multiselect
                        class="border border-blue-400"
                        v-bind="field"
                        v-model="department"
                        :options="helper.departmentOptions"
                        :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                        valueProp="value"
                        :searchable="true"
                        :noOptionsText="$lang.app.LIST_EMPTY"
                        :noResultsText="$lang.app.NOT_FOUND">
                    </multiselect>
                  </Field>
                  <ErrorMessage :name="`department`" class="text-xs text-red-400"/>
                </div>
              </div>
              <div class="mb-4">
                <div class="mb-1">
                  <label class="block text-blue-400 text-sm">
                    {{ $lang.app.EMPLOYEES }}
                  </label>
                </div>
                <ExecutorsMultiselect
                    :value="form.employees"
                    @update="form.employees = $event"
                    :options="helper.employeeOptions"/>
              </div>
            </div>
            <!-- footer -->
            <div class="flex items-center p-6 space-x-2 rounded-b border-t border-gray-200 dark:border-gray-600">
              <button
                  type="submit"
                  class="relative text-white bg-indigo-700 hover:bg-indigo-800 focus:ring-2 focus:outline-none
                  focus:ring-indigo-300 font-medium rounded text-md px-4 py-2 text-center"
                  :disabled="submitting"
              >
                {{ this.$lang.app.ADD }}
                <div v-if="submitting" class="absolute z-10 rounded w-full h-full top-0 left-0 bg-indigo-700 flex items-center justify-center">
                  <div class="block animate-spin">
                    <RefreshIcon class="w-6 h-6 mirror-y"/>
                  </div>
                </div>
              </button>
              <button
                  @click="$emit('close')"
                  type="button"
                  class="text-gray-500 bg-white hover:bg-gray-100 focus:ring-2 focus:outline-none focus:ring-indigo-300
                  rounded border border-gray-200 text-md font-medium px-4 py-2 hover:text-gray-900 focus:z-10"
              >
                {{ this.$lang.app.CLOSE }}
              </button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {Field, Form, ErrorMessage} from 'vee-validate';

import stateApi from "../../../../../api/employee/state";
import employeeApi from "../../../../../api/employee/employee";

import ExecutorsMultiselect from "../../inputs/ExecutorsMultiselect";
import departmentApi from "../../../../../api/employee/department";
import resolutionApi from "../../../../../api/employee/resolution";
import executorTypes from "../../../../../helpers/constants/executorTypes";

export default {
  props: {
    resolution: Object,
    userResolutionRole: String
  },
  components: {
    Field,
    Form,
    ErrorMessage,
    ExecutorsMultiselect
  },
  data() {
    return {
      submitting: false,

      state: null,
      department: null,
      form: {
        employees: [],
      },
      helper: {
        stateOptions: [],
        departmentOptions: [],
        employeeOptions: [],
      },
    };
  },
  watch: {
    'state'(value) {
      if (value) {
        this.department = null
        this.setDepartmentOptions(value)
      }
    },
    'department'(value) {
      if (value) {
        this.form.employees = []
        this.setEmployeeOptions(value)
      }
    },
  },
  methods: {
    initStateOptions() {
      stateApi.getStates().then((res) => {
        this.helper.stateOptions = res.map(stateItem => ({
          value: stateItem.id,
          label: this.$lang.$translate({ru: stateItem.nameRu, kg: stateItem.nameKg}),
        }))
        if(this.helper.stateOptions.length) {
          this.state = this.helper.stateOptions[0].value
        }
      })
    },
    setDepartmentOptions(value) {
      departmentApi.getDepartmentsByStateId(value).then((res) => {
        this.helper.departmentOptions = res.map(departmentItem => ({
          value: departmentItem.id,
          label: this.$lang.$translate({ru: departmentItem.nameRu, kg: departmentItem.nameKg}),
        }))
      })
    },
    setEmployeeOptions(value) {
      employeeApi.getEmployeesByDepartmentId(value).then((res) => {
        this.helper.employeeOptions = res.data?.map((item) => ({
          id: item.id,
          name: item.fullName,
          position: this.$lang.$translate({ru: item.position.nameRu, kg: item.position.nameKg}),
          type: executorTypes.getValueByKey('SIGNER'),
          vacation: item.activeVacation,
        }));
      });
    },
    submit(values, actions) {
      this.submitting = true
      resolutionApi.addExecutors(this.resolution.id, {
        userEmployments: this.form.employees.map(e => ({
          employment: e.id,
          type: executorTypes.getValueByKey('SIGNER')
        }))
      })
          .then(() => {
            this.$emit('close')
            this.$emitter.emit('refresh-application', {reload: false})
            this.$snotify.success(this.$lang.app.SUCCESS_ACTION)
          })
          .catch(error => {
            if (error.response.status === 422) {
              actions.setErrors(error.response.data.errors);
            } else {
              this.$snotify.error(error)
            }
          }).finally(() => {
        this.submitting = false
      })
    },
  },
  created() {
    if(this.userResolutionRole === 'ROLE_HEAD_OF_DEPARTMENT') {
      this.setEmployeeOptions(this.$store.getters.getCurrentUser.employment.position.department.id)
    } else {
      this.initStateOptions()
    }
  },
}
</script>
